import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {priceNonPrefixDataTableTemplate} from "../../../utils/formatters/Numbers";
import Divider from "@material-ui/core/Divider";

const InstrumentView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Mantenimiento \ Emisoras"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataInstruments}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <Button label="Agregar Emisora" className="p-button-secondary"
                                onClick={props.redirectAddInstrument}/> &nbsp;
                        {props.exportMenu}
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataInstruments}
                            selectionMode={"single"}
                            selection={props.selectedInstrument}
                            onSelectionChange={props.onSelectionChangeTable}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="idDemanda" header="Disponibilidad" body={props.formatAvailability}
                                    sortable={true}/>
                            <Column field="emisoraSerie" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="cupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="isin" header="ISIN" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="tipoValor" header="Tipo Valor" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="precioVal" header="Precio Valor" style={{textAlign: 'right'}}
                                    body={priceNonPrefixDataTableTemplate} sortable={true}/>
                            <Column field="precio24" header="Precio 24Hrs" style={{textAlign: 'right'}}
                                    body={priceNonPrefixDataTableTemplate} sortable={true}/>
                            <Column field="idGSS" header="ID GSS" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="cveAforo" header="Clave Aforo" style={{textAlign: 'left'}} sortable={true}/>
                            <Column header="Acciones" style={{textAlign: 'right', width: '10%'}}
                                    body={props.instrumentActionTemplate} />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default InstrumentView;